import React from 'react';
import { AppLink } from 'views/components/organisms/AppLink';
import styled from '@emotion/styled';
import { Color, ROUTER_PATH } from 'views/constants';
import {
  AvailableApplication,
  AvailableDistribution,
} from 'models/Device/type';
import { OwnerType } from 'models/Device/enum';
import { getRequestPath } from 'utils/string';
import { Driver } from 'views/components/atoms/Driver';

interface AppLinkListProps {
  applications: AvailableApplication[];
  distributions: AvailableDistribution[];
}

const Wrapper = styled.div`
  background-color: ${Color.C6};
`;

const appPath = (app: AvailableApplication): string => {
  return app.ownerType == OwnerType.user
    ? getRequestPath(ROUTER_PATH.userApp, {
        userName: app.ownerName,
        packageName: app.bundleIdentifier,
        revision: String(app.revision),
      })
    : getRequestPath(ROUTER_PATH.groupApp, {
        groupName: app.ownerName,
        packageName: app.bundleIdentifier,
        revision: String(app.revision),
      });
};

export const AppLinkList: React.FC<AppLinkListProps> = ({
  applications,
  distributions,
}) => (
  <Wrapper>
    {applications.map((app, index) => {
      return app.visible ? (
        <React.Fragment
          key={`applications-${app.ownerName}-${app.bundleIdentifier}-${app.revision}`}
        >
          <AppLink
            to={appPath(app)}
            iconSrc={app.iconSrc}
            title={app.title}
            version={app.version}
            ownerName={app.ownerName}
            bundleIdentifier={app.bundleIdentifier}
            revision={app.revision}
            message={app.releaseNote}
            updatedAt={app.updatedDate}
          />
          {distributions.length === 0 &&
          applications.length - 1 === index ? null : (
            <Driver />
          )}
        </React.Fragment>
      ) : null;
    })}

    {distributions.map((distribution, index) => (
      <React.Fragment key={distribution.accessKey}>
        <AppLink
          to={getRequestPath(ROUTER_PATH.distribution, {
            distributionAccessKey: distribution.accessKey,
          })}
          iconSrc={distribution.iconSrc}
          title={distribution.applicationName}
          version={distribution.version}
          ownerName={distribution.ownerName}
          bundleIdentifier={distribution.applicationBundleIdentifier}
          revision={distribution.revision}
          distributionName={distribution.title}
          updatedAt={distribution.updatedDate}
        />
        {distributions.length - 1 === index ? null : <Driver />}
      </React.Fragment>
    ))}
  </Wrapper>
);
